module.exports = __webpack_public_path__ + "static/img/4.294faf78.jpg";